module.exports = __webpack_public_path__ + "img/logo.5e055714.png";